<template>
	<div id="testProductList" class="center center-padding">
		<div style="position:sticky;top:50px;background:var(--base);padding:5px;z-index:20;">
			<div class="flexheader">
				<Button label="Hämta" @click="product()" />
				<div class="form textField" :title="'filter: ' + this.tableConfig.filter">
					<input type="text" placeholder="Value..." v-model="filterInput" />
					<img src="@/assets/button_close.png" @click="this.filterInput = ''" />
				</div>

				<div class="flexcenter debug" v-if="debug"> {{ filterInput }} : {{ filter }} </div>



				<b style=" flex-grow:1">&nbsp;</b>
				<div style="background:var(--dark);" class="flexcenter badge" title="Visar på sidan / Träffar / Totalt"> {{
					model.list.length }} / {{ model.resultCount }}
					/
					{{
						model.totalCount }}
				</div>
			</div>
		</div>



		<div id="resultList" style="">
			<table class="dataTable">
				<thead>
					<tr>
						<th>
							<div>ROW</div>

						</th>
						<th @click="headerClicked('productId')">
							<HeaderSort property="productId" label="ID" :tableConfig="this.tableConfig" />
						</th>
						<th @click="headerClicked('artnr')">
							<HeaderSort property="artnr" label="Artikelnummer" :tableConfig="this.tableConfig" />
						</th>
						<th @click="headerClicked('name')">
							<HeaderSort property="name" label="Produktnamn" :tableConfig="this.tableConfig" />
						</th>

					</tr>
				</thead>
				<TestProductRow class="product" v-for="(product, index) in model.list" :key="index" :rowIndex="index"
					:productId="product.productId" :class="{ odd: index % 2 === 0 }" />

			</table>
		</div>
	</div>
</template>

<script>
// height:calc(100vh - 260px);overflow:scroll;overscroll-behavior: contain;


import HeaderSort from '../../components/HeaderSort.vue';
import { PRODUCT_STORE_ACTION } from '../../store/product-store';
import { STORE_GETTER, STORE_COMMIT } from '../../store/store';
import TestProductRow from './TestProductRow.vue';


import listHelper from "@/helper/list-helper.js";


export default {
	name: "TestProductList",
	components: { TestProductRow, HeaderSort },
	mixins: [],
	data() {
		return {
			result: null,
			filterInput: "",
			currentScrollFromTop: 0,
			trackScrollingOn: "resultList"


		};
	},
	watch: {
		filterInput: function (filter) {
			console.log("FP: watcher: ", filter);

			/*if (!filter) {
				return;
			}*/

			if (filter && filter.length > 2) {
				this.filterChanged(filter)
			}

			if (filter == null || filter == "") {
				this.filterChanged(null)
			}
		}
	},
	computed: {
		model() {

			var model = { totalCount: 0, list: [] };

			var list = this.$store.state.productStore.data.productList.filter(product => product !== null);
			model.totalCount = list.length

			if (this.tableConfig.filter && this.tableConfig.filter.length > 0) {
				list = listHelper.filterList(list, this.tableConfig.filter)
			}

			model.list = listHelper.sortList(list, this.tableConfig.sort, this.tableConfig.desc);

			model.resultCount = model.list.length;

			model.list = listHelper.trimToLimit(model.list, this.tableConfig.scrollLimit);

			return model;


		},
		tableConfig() {
			//const tableConfig = this.$store.getters[STORE_GETTER.TABLE_CONFIGS].find((tableConfig) => { return tableConfig.key == "testProductList" });

			const tableConfig = this.$store.getters[STORE_GETTER.TABLE_CONFIGS].find(tableConfig => tableConfig.key == "testProductList")
			console.log('FP: found tableConfig: ', tableConfig);


			if (tableConfig) {
				return tableConfig;
			}

			return { key: "testProductList", defaultScrollLimit: 50, scrollLimit: 50, append: 50, filter: "", sort: "", desc: true } // defaultvärden
		},

		productListTrimmed() {
			return listHelper.trimToLimit(this.productList, this.limit); // visar bara delar av listan
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
		},
		requestCount() {
			return this.$store.getters[STORE_GETTER.REQUEST_COUNT]
			//return this.$store.state.productStore.data.requestCount
		}

	},
	methods: {
		product() {
			this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });
		},


		headerClicked(property) {
			const tableConfig = this.tableConfig
			tableConfig.sort = property
			tableConfig.desc = !tableConfig.desc
			tableConfig.scrollLimit = tableConfig.defaultScrollLimit

			this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			this.resetScroll();

		},

		filterChanged(filter) {

			const tableConfig = this.tableConfig
			tableConfig.filter = filter;
			tableConfig.scrollLimit = tableConfig.defaultScrollLimit

			this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			this.resetScroll()

		},

		resetScroll() {
			this.currentScrollFromTop = 0
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},

		trackScrolling() {

			const element = document.getElementById(this.trackScrollingOn);
			const scrollFromTop = element.scrollTop + element.clientHeight + 100
			const value = element.scrollHeight < scrollFromTop;

			//console.log('FP: element.scrollHeight:', element.scrollHeight);
			//console.log('FP: element.scrollTop + element.clientHeight + 100:', element.scrollTop + element.clientHeight + 100);

			if (value && scrollFromTop > this.currentScrollFromTop) {
				this.currentScrollFromTop = scrollFromTop
				const tableConfig = this.tableConfig
				tableConfig.scrollLimit += tableConfig.append
				this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			}
		},
		trackScrollingDocument() {


			// @var int totalPageHeight
			var totalPageHeight = document.body.scrollHeight;

			// @var int scrollPoint
			var scrollFromTop = window.scrollY + window.innerHeight + 100;


			var value = totalPageHeight - (scrollFromTop);
			// check if we hit the bottom of the page
			//if (scrollPoint >= totalPageHeight) {
			//console.log("at the bottom");
			//}
			if (value < 0 && scrollFromTop > this.currentScrollFromTop) {
				this.currentScrollFromTop = scrollFromTop
				const tableConfig = this.tableConfig
				tableConfig.scrollLimit += tableConfig.append
				this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			}


			/*console.log('FP: window.scrollY: ', window.scrollY);
			console.log('FP: window.innerHeight: ', window.innerHeight);
			console.log('FP: value: ', value);
*/

			//console.log('FP: element.scrollHeight:', element.scrollHeight);
			//console.log('FP: element.scrollTop + element.clientHeight + 100:', element.scrollTop + element.clientHeight + 100);

			/*if (value && scrollFromTop > this.currentScrollFromTop) {
				this.currentScrollFromTop = scrollFromTop
				const tableConfig = this.tableConfig
				tableConfig.scrollLimit += tableConfig.append
				this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			}*/
		}

	},
	mounted() {
		//document.getElementById(this.trackScrollingOn).addEventListener("scroll", this.trackScrolling);
		document.addEventListener("scroll", this.trackScrollingDocument);

		if (this.tableConfig && this.tableConfig.filter) {
			this.filterInput = this.tableConfig.filter
		}

		this.product();

	},

	unmounted() {
		//const element = document.getElementById(this.trackScrollingOn);

		//if (element) {
		//element.removeEventListener("scroll", this.trackScrolling);
		document.removeEventListener("scroll", this.trackScrollingDocument);
		//}
	},
};
</script>

<style scoped>
html body div#app div div#page div.content div#testProductList div#resultList table.dataTable thead tr th {
	top: 222px;

}
</style>
